'use strict';
var AkrisOrderSummaryController = /** @class */ (function () {
    /* @ngInject*/
    function AkrisOrderSummaryController(Auth, $state, $scope, $mdDialog, $q, $window) {
        this.tableColSpan = 5;
        this.Auth = Auth;
        this.$state = $state;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$q = $q;
        this.$window = $window;
    }
    AkrisOrderSummaryController.prototype.$onInit = function () {
        var _this = this;
        var self = this;
        // Check User is Logged in or not
        this.Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                self.loggedInUser = loggedInUser;
                if (self.loggedInUser.isImpersonated) {
                    _this.getOrderHoldCodes();
                }
                self.tableColSpan = self.loggedInUser.accountType === 'Practitioner' ? 5 : 4;
            }
            if (loggedInUser == null) {
                _this.$window.location = '/auth/ares';
            }
        });
    };
    AkrisOrderSummaryController.prototype.$onChanges = function (changes) {
        if (changes.cart) {
            this.cart = Object.assign({}, this.cart);
            if (this.cart.aresLineItems) {
                this.fillCart(this.cart);
            }
        }
    };
    AkrisOrderSummaryController.prototype.fillCart = function (cart) {
        var self = this;
        self.quantityOfCartItems = cart.quantityOfCartItems;
        self.subTotal = cart.subTotal;
        self.shipTotal = cart.shipVia.shipCost;
        self.taxTotal = cart.taxTotal;
        self.totalShippingDiscount = cart.totalShippingDiscount;
        self.total = cart.total;
        self.discountTotal = cart.discountTotal;
        self.selectedPayment = cart.payment;
    };
    return AkrisOrderSummaryController;
}());
export default AkrisOrderSummaryController;
//# sourceMappingURL=akris-order-summary-list.controller.js.map